import { useMemo } from 'react';
import useLocale from 'hooks/useLocale';
import text from 'constants/ui';

const useLocaleTxt = () => {
  const locale = useLocale();

  return useMemo(() => text[locale.slug], [locale]);
};

export default useLocaleTxt;
